import { render, staticRenderFns } from "./status-box.vue?vue&type=template&id=2d41985c&scoped=true"
import script from "./status-box.vue?vue&type=script&lang=js"
export * from "./status-box.vue?vue&type=script&lang=js"
import style0 from "./status-box.vue?vue&type=style&index=0&id=2d41985c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d41985c",
  null
  
)

export default component.exports